import { ChevronIcon } from 'components/icons'
import classNames from 'helpers/class-names'
import { FC, HTMLAttributes } from 'react'

interface Props extends HTMLAttributes<HTMLTableCellElement> {
  order?: 'asc' | 'desc'
}

export const TableHead: FC<Props> = ({ children, order, ...props }) => {
  return (
    <th
      {...props}
      className={classNames('h-8 px-2 first-of-type:px-3', props.className)}>
      <button
        className={classNames(
          'flex w-full flex-row items-center gap-0.5 truncate rounded-md outline-none focus-visible:underline',
        )}
        tabIndex={!children || children === '' ? -1 : 0}>
        <span className="truncate">{children}</span>
        {order && (
          <ChevronIcon
            className={classNames('size-3 shrink-0', {
              '-rotate-90': order === 'asc',
              'rotate-90': order === 'desc',
            })}
          />
        )}
      </button>
    </th>
  )
}
